import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

import { useGame, useUser } from 'data/hooks'

export const useAwards = (gameId) => {

  const dispatch = useDispatch()
  const { userId } = useUser()
  const { events, data } = useGame(gameId)


  const redeemAward = (awardId) => {

    return dispatch(actions.redeemAmazonAward(gameId, userId, awardId))
  }

  return {
    events,
    awards: data?.awards || [],
    redeemAward
    /*
    awards: data?.awards.map(award => {
      return {
        ...award,
        event: Object.values(events).find(event => event.awards.find(eventaward => eventaward.awardId === award.awardId))
      }
    })
    */
  }
}
